module.exports = __webpack_public_path__ + "static/img/Piety.ce6b63bd.jpeg";